import React from 'react';
import Game from './Game';


function App() {
  return (
    <Game />
  );
}

export default App;
